module.exports = __webpack_public_path__ + "img/dodCircleRemove.2d6c1aa4.svg";